import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import OrgAccessIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/access-control'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'org_access_index',
          component: OrgAccessIndex,
          meta: {
            permissions: [
              'administrator',
              'org_structure_manage',
              'access_role_manage',
            ],
          },
        },
      ],
    },
  ],
};
